import {
  BehaviorSubject
} from 'rxjs/BehaviorSubject';
import {
  StatusBar
} from '@ionic-native/status-bar';
import {
  Mileage
} from './../../objects/real-time';
import {
  StopList
} from './../stop-list/stop-list';
import {
  PointInterest,
  Driver
} from './../../objects/data-management';
import {
  Component,
  ViewChild,
  OnInit
} from '@angular/core';
import {
  NavController,
  NavParams,
  ModalController,
  AlertController,
  MenuController,
  LoadingController,
  App,
  ToastController,
  ViewController,
  ActionSheetController,
  Platform,
  PopoverController
} from 'ionic-angular';
import {
  DatePipe,
  DecimalPipe
} from '@angular/common';
import {
  MapService
} from "../../utils/map.service";
import {
  HistoricalService
} from "../../providers/historical.service";
import {
  DataManagementService
} from "../../providers/data-management.service";
import {
  HistoricalForm
} from '../historical-form/historical-form';
import {
  PathsList
} from '../paths-list/paths-list';
import {
  Subscription
} from "rxjs";
import {
  GlobalService
} from "../../providers/global.config";
import {
  GeocodingService
} from '../../utils/geocoding.service';
import * as L from 'leaflet';
import Polygon = L.Polygon;
import Marker = L.Marker;
import Icon = L.Icon;
import 'leaflet';
import 'leaflet.markercluster'; 
//import 'leaflet-rotatedmarker';
import {
  RealTimeService
} from '../../providers/real-time.service';
import {
  Observable
} from 'rxjs/Rx';
import {
  HomePage
} from '../home/home';
import {
  GroupsPage
} from '../groups-page/groups-page';
import {
  RealTimeRecord,
  Group,
  Vehicule
} from "../../objects/real-time";
import {
  Poi
} from '../poi/poi';
import {
  CallNumber
} from '@ionic-native/call-number';
import {
  Storage
} from '@ionic/storage';
import {
  Geolocation
} from '@ionic-native/geolocation';
import {
  Stop
} from '../../objects/real-time';
import {
  MileageComponent
} from '../mileage/mileage';
import {
  LaunchNavigator,
  LaunchNavigatorOptions
} from '@ionic-native/launch-navigator';
import {
  GroupeRealtime
} from '../groups-page/group-realtime/group-realtime';
import {
  GestionPark
} from '../gestion-park/gest-park';
import {
  trigger,
  transition,
  style,
  animate,
  state
} from '@angular/core'
import {
  BrowserAnimationsModule
} from '@angular/platform-browser/animations';
import {
  BrowserModule
} from '@angular/platform-browser';
import {
  Events
} from 'ionic-angular/util/events';
import {
  jqxGaugeComponent
} from '../../assets/jqwidgets-ts/angular_jqxgauge';
import {
  ElementRef
} from '@angular/core';
import {
  InfoTrackerPage
} from '../../pages/info-tracker/info-tracker';
import {HeaderService} from "../../providers/header.service";
import { CompleteTestService } from '../../providers/CompleteTestService';
import {AutoCompleteComponent} from 'ionic2-auto-complete';
import { PromptPage } from '../popping-pages/prompt/prompt';
import { DashboardPage } from '../dashboard/dashboard';

//import  'leaflet/dist/leaflet-src.js';

@Component({
  selector: 'page-historical',
  animations: [
    trigger(
      'myAnimation', [
        transition(
          ':enter', [
            style({
              transform: 'translateY(100%)',
              opacity: 0
            }),
            animate('200ms', style({
              transform: 'translateY(0)',
              'opacity': 1
            }))
          ]
        ),
        transition(
          ':leave', [
            style({
              transform: 'translateY(0)',
              'opacity': 1
            }),
            animate('400ms', style({
              transform: 'translateY(100%)',
              'opacity': 0
            }))

          ]
        )
      ]
    )
  ],
  templateUrl: 'historical.html'
})

export class Historical implements OnInit {
  @ViewChild('mycontent') nav: NavController

  @ViewChild('myGauge') myGauge: jqxGaugeComponent;
  @ViewChild('gaugeValue') gaugeValue: ElementRef;
  @ViewChild('searchbar')
  searchbar: AutoCompleteComponent;
  // ngAfterViewInit(): void {
  //   this.myGauge.value(0);   
  //  }
  //labels: any = { position: 'outside', interval: 20 };
  labels: any = {
    position: 'outside',
    interval: 20,
    formatValue: (value: number, position: string): string => {
      if (value < 181)
        return value + '';
    }
  };
  ticksMinor: any = {
    interval: 5,
    size: '5%'
  };

  ticksMajor: any = {
    interval: 10,
    size: '10%'
  };

  cap: any = {
    size: '5%',
    style: {
      fill: '#2e79bb',
      stroke: '#2e79bb'
    }
  };

  border: any = {
    style: {
      fill: '#8e9495',
      stroke: '#7b8384',
      'stroke-width': 1
    }
  };

  pointer: any = {
    style: {
      fill: '#2e79bb'
    },
    width: 5
  };

  ranges: any[] = [{
      startValue: 0,
      endValue: 60,
      style: {
        fill: '#4cb848',
        stroke: '#4cb848'
      },
      startDistance: 0,
      endDistance: 0
    },
    {
      startValue: 60,
      endValue: 100,
      style: {
        fill: '#fad00b',
        stroke: '#fad00b'
      },
      startDistance: 0,
      endDistance: 0
    },
    {
      startValue: 100,
      endValue: 180,
      style: {
        fill: '#e53d37',
        stroke: '#e53d37'
      },
      startDistance: 0,
      endDistance: 0
    }
  ];
  dash = -30;
  setShowDashbord() {
    if (this.dash == -30)
      this.dash = -140;
    else
      this.dash = -30;
  }
  getShowDashbord() {
    return this.dash;
  }
  show: boolean = false;
  vehicule: any;
  groupmodal: any;
  recordtime: any;
  matricule: any = "Temps Réel";
  realtimecoord: any;
  mileageClicked: Mileage;
  stopClicked: Stop;
  pois: Poi[];
  stops: Stop[] = [];
  firstDate: any;
  lastDate: any;
  pointInterests: PointInterest[] = null;
  allRealTimeRecords: Subscription;
  allGroups: Subscription;
  allPaths: Subscription;
  paths: any[];
  loader: any;
  selectedDevice: any;
  oldRealTimeRecords: RealTimeRecord[] = null;
  angles: Map < number, number > = new Map();
  pathDrawn: boolean = false;
  previousPathdrawn: boolean = false;
  pathDraw: boolean = false;
  currentPathClickedDeviceIds: number[] = null;
  currentPathClickedDeviceId: number = null;
  modalopen: boolean = false;
  dismissbutton: boolean = false;
  driverphone: string;
  poisInMap: boolean = false;
  latpoi: any;
  lngpoi: any;
  addresspoi: any;
  currentlocationlat: any;
  currentlocationlng: any;
  resultopened: boolean = false;
  openStopResult: boolean = false;
  openMileageResult: boolean = false;
  AllPaths: any;
  mileages: Mileage[] = [];
  totalMileage: Mileage;
  pathpoirealtime: boolean = false;
  Root: boolean;
  relativeposition: string;
  vitesse: number;
  imageUri: string = "../../assets/icons/c1x0.png";
  history:boolean=false;
  public groups: any[] = [];
  searchWord: string = "";
  newRealTimeRecords: RealTimeRecord[] = null;
  private realTimeRecordsItemSource = new BehaviorSubject < RealTimeRecord[] > ([]);
  data:any[] = [];
  hideMe = false;
  hideGroupi = false;
  visibleV = false;
  visibleG = false;
  searchfield = false;

public shownGroup : any[] = [];
numb : any;
cluster:any;
isCurrentPathClicked: boolean = false;
searchTerm: string = '';
isGroupLoaded: boolean = false;

running: number = 0;
    technicalIsue: number = 0;
    stop: number = 0;

charged : boolean = false;
id1:any;
id2:any;

 i :number=0;
 groupid : any;

    //notification
    notifications: Notification[];
    notificationNbr: number = 0;
    startDate: Date = new Date();
    endDate: Date = new Date();

carStatus : string = "chargement ..";
 imagesDir = this.globalService.getimagesDir();
imagesPOIDir = this.globalService.getimagesPOIDir();
imagescar = this.globalService.getimagescar();
isClicked:boolean=false;
positionMarker:any;
circle:any;
  constructor(public plm: Platform,
   public events: Events,
    private menu: MenuController,
     statusBar: StatusBar,
      private alertCtrl: AlertController,
       private launchNavigator: LaunchNavigator,
        private geolocation: Geolocation,
         public actionSheetCtrl: ActionSheetController,
          public viewCtrl: ViewController,
           private callNumber: CallNumber,
            private storage: Storage,
             private pipe: DecimalPipe,
              public toastController: ToastController,
               private realTimeService: RealTimeService,
                private geocodingService: GeocodingService,
                 private dataManagementService: DataManagementService,
                  public _app: App,
                   private historicalService: HistoricalService,
                    public loadingCtrl: LoadingController,
                     public modalCtrl: ModalController,
                      public navCtrl: NavController,
                       public navParams: NavParams,
                        public mapService: MapService,
                        public loading : LoadingController,
                        public headerService : HeaderService,
                        public completeTestService: CompleteTestService,
                         private globalService : GlobalService,
                         private popoverCtrl: PopoverController) {
//----------------
/// openResultsModal()
events.subscribe('openResultsModal', () => {
  this.openResultsModal();
});
//openGroupsModal()
events.subscribe('openGroupsModal', () => {
  this.openGroupsModal();
});
//openmenu()
events.subscribe('openmenu', () => {
  this.openmenu();
});
//--------------------------
//loadMap()
events.subscribe('loadMap', () => {
  this.loadMap();
});



    this.navCtrl.swipeBackEnabled = false;
    this.totalMileage = new Mileage();
    this.Root = JSON.parse(localStorage.getItem('currentuser')).isRoot;
   
  /*  events.subscribe('ShowOption', x => {
      if (x) {
        this.show = !this.show;
         console.log(this.show);
      } else this.show = false;
    });
*/


  }
ngOnInit(){
  this.geolocation.getCurrentPosition().then((resp) => {
    this.currentlocationlat = resp.coords.latitude;
    this.currentlocationlng = resp.coords.longitude;
  }).catch((error) => {
    console.log('Error getting location', error);
  });
}
  currentPosition(){
    let vehicule = this.getVehicule(this.selectedDevice);
    
    if(!this.isClicked)
    {
      this.mapService.map.flyTo(L.latLng(this.currentlocationlat, this.currentlocationlng),15);
      this.positionMarker = L.marker([this.currentlocationlat,this.currentlocationlng]).addTo(this.mapService.map);
      this.circle = L.circle([this.currentlocationlat,this.currentlocationlng], {
      fillOpacity: 0.2,
      radius: 500
      }).addTo(this.mapService.map);

      this.isClicked=!this.isClicked;

    }
    else
    {
      this.mapService.map.removeLayer(this.positionMarker);
      this.mapService.map.removeLayer(this.circle);
      this.mapService.map.setView(L.latLng(vehicule.realTimeRecord.coordinate.lat, vehicule.realTimeRecord.coordinate.lng),8);
      this.isClicked=!this.isClicked;
    }
    
    
  } 

  arreterDemarrer(ev){
    let vehicule = this.getVehicule(this.selectedDevice);
    let group = this.getGroup(this.groupid);
    let selectedV = {"group" :group,"vehicule" :vehicule,"indexGroup":this.id1, "indexVehicule" :this.id2};
    

    let popover = this.popoverCtrl.create(PromptPage,{selectedDevice:this.selectedDevice});
    popover.present({
      ev: ev
    });
    
  }

chargingGroupInfoInSideBar(){
  this.events.publish("chargingGroupInfo");
}


ionViewDidLoad() {

this.loadMap();
//this.getAllNotifications(); 
  
}


 //get All Notifications
    getAllNotifications(){
        this.headerService.getListAlerts({startDate: this.startDate, endDate: this.endDate
        }).subscribe(alerts => {
            this.notifications = alerts;
         })
    }

//---------------

//selection group and go to group-realtime.ts
  selectedGroup(group: any) {
    this.groupmodal = this.modalCtrl.create(GroupeRealtime, {
      group
    });
    this.groupmodal.present();
    this.groupmodal.onDidDismiss(data => {
      if (data) {
        this.viewCtrl.dismiss(data);
      }
    });

  }
  //fermer modal
  closeModal() {
    this.viewCtrl.dismiss(null);
  }

  // ngAfterViewInit() {

  //   // this.content.ionScroll.subscribe(($event: any) => {
  //   //   let dimensions = this.content.getContentDimensions();
  //   //   let scrollHeight = dimensions.scrollHeight;
  //   //   let scrollTop = dimensions.scrollTop;
  //   //   let contentHeight = dimensions.contentHeight;
  //   //   let heightAndScrollTop = contentHeight + scrollTop;
  //   //   if((scrollHeight - heightAndScrollTop) <= 0 && (scrollHeight - heightAndScrollTop) >= 0) { 
  //   //     this.realTimeService.findVehiculesByGroupsId(15,1,0).subscribe(x=>{
  //   //       console.log(x);
  //   //     })
  //   //   }
  //   // });
  // }

generateGroups() {
    this.data = this.groups;
    return this.data;
  }

 generateGroups2() {
    this.data;
    
    //console.log(this.data);
  }

  getItems(ev: any) {
    // Reset items back to all of the items
    //this.groups=this.data;
    this.generateGroups();
    this.generateGroups2();

    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.data = this.data.filter((group) => {
        this.searchWord = val;
        console.log(val);
        console.log(this.data);
        //this.groups = this.data;
        return (group.nom.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }


  goToRealTimeRecord(deviceId: Vehicule,isvalid:boolean){
    if(isvalid){

    let data={vehicule: deviceId ,groups:this.groups}
    this.viewCtrl.dismiss(data);
    }
  }
  loadGroups() {
    this.allGroups = this.realTimeService.getAllGroups(this.searchWord).subscribe(groupes => {
      this.groups = groupes;
      console.log(this.groups);

      this.groups.forEach(group => {
        group.vehicules.forEach(vehicule => {
         // console.log(vehicule.idDevice);
          vehicule.realTimeRecord=new RealTimeRecord();
          this.realTimeService.getRealTimeRecord(vehicule.idDevice).subscribe(x=>{

            vehicule.realTimeRecord = x;
            vehicule.realTimeRecord.vehicule=new RealTimeRecord();
            vehicule.realTimeRecord.vehicule=vehicule;
            vehicule.realTimeRecord.vehicule.idGroup=group.idGroupe;
            this.getCalTravels(vehicule.realTimeRecord.vehicule);
            this.trackRealTimeRecord(vehicule.realTimeRecord);
          },(err) => {

          });

        })
      });
    });
    this.getAllRealTimeRecords();
     this.isGroupLoaded = true;
  }
  loadadress(realTimeRecord: RealTimeRecord){
    this.geocodingService.inverseGeoconding(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng, 18).subscribe(adress => { 
      realTimeRecord.vehicule.realTimeRecord.geocoding = this.geocodingService.proccessingNomitamAddress(adress);
      realTimeRecord.geocodingDetails = adress.display_name;
      this.updateSpecificGroups(realTimeRecord);
      

  },(err) => {

  });
  }
  getCalTravels(vehicule:any) {
    this.dataManagementService
      .getCalTravels()
      .subscribe(calTravels => {
        calTravels.forEach(caltravel=>{
          if(caltravel.deviceId==vehicule.idDevice){
            vehicule.odo= Math.floor((vehicule.odoOffset+caltravel.accumOdo) * 100) / 100;
             // console.log(vehicule.matricule+"=>"+vehicule.odo)
          }
          
        })
      });
  }  
  getAllRealTimeRecords() {
    /*
    this.mapService.initCluster();
    this.allRealTimeRecords = this.realTimeService.getAllRealTimeRecords().subscribe(realTimeRecords => {
      this.realTimeRecordsItemSource.next(realTimeRecords);
      if (this.newRealTimeRecords) {
        this.oldRealTimeRecords = this.newRealTimeRecords;
      }
      this.newRealTimeRecords = realTimeRecords;
      realTimeRecords.forEach(realTimeRecord => {
       // console.log(realTimeRecord)
        realTimeRecord.vehicule = this.getVehicule(realTimeRecord.idRealTimeRecord);

         this.trackRealTimeRecord(realTimeRecord);
        });
      });*/


        this.mapService.initCluster();
        this.allRealTimeRecords = this.realTimeService.getAllRealTimeRecords().subscribe(realTimeRecords => {
           this.realTimeRecordsItemSource.next(realTimeRecords);
            // Keep trace of oldRealTimeRecords !!!
            this.getEtatVehicules(realTimeRecords)
            if (this.newRealTimeRecords) {
                this.oldRealTimeRecords = this.newRealTimeRecords;
            }
            this.newRealTimeRecords = realTimeRecords;
            realTimeRecords.forEach(realTimeRecord => {

                realTimeRecord.vehicule = this.getVehicule(realTimeRecord.idRealTimeRecord);
                this.trackRealTimeRecord(realTimeRecord);
                //update table !
                this.updateSpecificGroups(realTimeRecord);




    });
          });


      }


    getEtatVehicules(newRealTimeRecords: RealTimeRecord[]) {       
       if(newRealTimeRecords!=null){
           this.running=0;
           this.stop=0;
           this.technicalIsue=0;
        for (let i = 0; i < newRealTimeRecords.length; i++) {
            if (newRealTimeRecords[i].realTimeRecordStatus == 'VALID' && newRealTimeRecords[i].speed == 0 && newRealTimeRecords[i].ignition == false)
                this.stop++;
            if (newRealTimeRecords[i].realTimeRecordStatus == 'VALID' && newRealTimeRecords[i].speed == 0 && newRealTimeRecords[i].ignition == true)
                this.running++;
            if (newRealTimeRecords[i].realTimeRecordStatus == 'VALID' && newRealTimeRecords[i].speed > 0)
                this.running++;
            if (newRealTimeRecords[i].realTimeRecordStatus == 'NON_VALID')
                this.stop++;
            if (newRealTimeRecords[i].realTimeRecordStatus == 'TECHNICAL_ISSUE')
                this.technicalIsue++;
        }
        let total=this.running+this.stop+this.technicalIsue;
       }
    }

  getVehicule(idDevice: number): Vehicule {
    let foundVehicule = new Vehicule();
    for (let i = 0; i < this.groups.length; i++) {
      for (let j = 0; j < this.groups[i].vehicules.length; j++) {
        if (this.groups[i].vehicules[j].idDevice == idDevice) {
          foundVehicule = this.groups[i].vehicules[j];
          break;
        }
      }
    }
    return foundVehicule;
  }
    trackRealTimeRecord(realTimeRecord: RealTimeRecord) {
      let angle = 0;

      var date = new Date(realTimeRecord.recordTime);
      let today = new Date();
      //console.log(today);
      //console.log("fff",realTimeRecord.recordTime);
      //console.log(date);
      //let localtime = date.getTime();
      //console.log(localtime);
      //let localoff = date.getTimezoneOffset() * 60000;
      //console.log(localoff);
      realTimeRecord.recordTime=new Date(new Date(realTimeRecord.recordTime).setHours(new Date(realTimeRecord.recordTime).getHours()-1));
      var minutes = date.getMinutes() + "";
      if (minutes.length == 1) {
        minutes = "0" + date.getMinutes();
      }
      let icon;
      let marker;
      let popup;
      if (!this.dataManagementService.pointInterests) {
        this.dataManagementService.getAllPointInterests().subscribe(pointInterests => {
          this.dataManagementService.pointInterests = pointInterests;
          realTimeRecord.relativePosition = this.dataManagementService.getRelativePosition(
            realTimeRecord.coordinate.lat, 
            realTimeRecord.coordinate.lng);
        });
      }
      else {
        realTimeRecord.relativePosition = this.dataManagementService.getRelativePosition(
          realTimeRecord.coordinate.lat,
           realTimeRecord.coordinate.lng);
      }
      if (realTimeRecord.type === "AA") {
        angle = realTimeRecord.rotationAngle * 8;
      }
      if (this.oldRealTimeRecords && realTimeRecord.type === "GPRMC") {
        let oldRealTimeRecord = this.getOldRealTimeRecord(realTimeRecord.idRealTimeRecord);
        if (oldRealTimeRecord) {
          if (!this.compareTwoCoordinate(oldRealTimeRecord.coordinate, realTimeRecord.coordinate)) {
            angle = Math.atan2(realTimeRecord.coordinate.lng - oldRealTimeRecord.coordinate.lng, realTimeRecord.coordinate.lat - oldRealTimeRecord.coordinate.lat) * 180 / Math.PI;
            this.angles.set(realTimeRecord.idRealTimeRecord, angle);
          } else {
            angle = this.angles.get(realTimeRecord.idRealTimeRecord);
          }
        }
      }
     
      this.geocodingService.inverseGeoconding(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng, 18).subscribe(adress => { 
        realTimeRecord.vehicule.realTimeRecord.geocoding = this.geocodingService.proccessingNomitamAddress(adress);
        realTimeRecord.geocodingDetails = adress.display_name;
        this.updateSpecificGroups(realTimeRecord);
        
  
    },(err) => {
  
    });
     
     let geocoding = realTimeRecord.vehicule.realTimeRecord.geocoding;
     if (!geocoding){
       geocoding = "Chargement position..."
     }
     
      popup = '<div style="background-color:'+ this.carStatusColor(realTimeRecord) +';border-radius:10px;">'+'<span style="color:white; padding-left:10px;">'+this.carStatus + '</span></div>'+
      '<br><b>Matricule:</b> <b style="font-size:14.5px;">' + realTimeRecord.vehicule.matricule + "</b>" +
      '<br><b>Chauffeur:</b> ' + this.dataManagementService.getDriverName(realTimeRecord.vehicule.driver) +
      '<br><b>Marque:</b> ' + realTimeRecord.vehicule.mark +
      //'<br><b>Lat,Lng:</b><i> [' + this.PipeLngLat(realTimeRecord.coordinate.lat) + ',' + this.PipeLngLat(realTimeRecord.coordinate.lng) + ']</i>
      '<br><b>Vitesse :</b>' + realTimeRecord.speed +" Km/h"+
      "<br><b>Kilométrage :</b>" +
      Math.round(realTimeRecord.vehicule.odo) +
      "<br><b>Date et l'heure:</b> " + date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours()) + ':' + minutes +
      "<br><b>Signal GSM:</b> " + realTimeRecord.signal +
      " <i class='fa fa-wifi' aria-hidden='true'></i><br><b>Sat en vue:</b> " + realTimeRecord.satInView + " <i class='fa fa-globe' aria-hidden='true'></i>"
      +"<br><b style='text-align: center;color:#9D9D9D'> " + geocoding +"</b>";

 // console.log(this.vehicule);
   //  this.selectedDevice = this.vehicule.device.idDevice;

    //this.imageUri:string = "/images/c1x0.png";

     /* if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed == 0 && realTimeRecord.ignition== true) {
        icon =  L.icon({
          iconUrl: imagescar + "c4x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -10],
          iconSize:     [35, 35] 
        });
       this.imageUri = imagescar+ "c4x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
      }
      if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed > 0 ) {
        icon =  L.icon({
          iconUrl: imagescar + "c1x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25],
          iconSize:     [35, 35]
        });
        this.imageUri = imagescar + "c1x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
      }
      if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed == 0 && realTimeRecord.ignition== false) {
        icon = L.icon({
          iconUrl: imagescar + "c2x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25],
          iconSize:     [35, 35] 
        });
        this.imageUri = imagescar + "c2x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
      }
      if (realTimeRecord.realTimeRecordStatus == 'NON_VALID' || realTimeRecord.realTimeRecordStatus == 'TECHNICAL_ISSUE') {
        icon = L.icon({
          iconUrl: imagescar + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25],
          iconSize:     [35, 35] 
        });
        this.imageUri = imagescar + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
      }*/
      

      if (realTimeRecord.realTimeRecordStatus == 'VALID') {
        if(realTimeRecord.ignition== true){
          if(realTimeRecord.speed > 0 ){
            icon =  L.divIcon({
          iconSize: [200, 30],
          iconAnchor: [15, 15],
          popupAnchor: [10, -25],
          className: 'my-div-icon',
           html: '<img class="my-div-image" src="'+this.imagescar+'c1x'
           +Math.abs(Math.round(angle / 45) * 45)+'.png">'+
              '<br><span class="my-div-span">'+realTimeRecord.vehicule.matricule +'</span>'
        });
        this.imageUri = this.imagescar + "c1x" + Math.abs(Math.round(angle / 45) * 45) + ".png";



     }else{

          icon =  L.divIcon({
          iconSize: [200, 30],
          iconAnchor: [15, 15],
          popupAnchor: [10, -25],
          className: 'my-div-icon',
           html: '<img class="my-div-image" src="'+this.imagescar+'c4x'
           +Math.abs(Math.round(angle / 45) * 45)+'.png">'+
              '<br><span class="my-div-span">'+realTimeRecord.vehicule.matricule +'</span>'
        });
       this.imageUri = this.imagescar+ "c4x" + Math.abs(Math.round(angle / 45) * 45) + ".png";

        
     }}else{
       if(realTimeRecord.speed == 0 ){
         icon = L.divIcon({
          iconSize: [200, 30],
          iconAnchor: [15, 15],
          popupAnchor: [10, -25],
          className: 'my-div-icon',
          html: '<img class="my-div-image" src="'+this.imagescar+'c2x'
          +Math.abs(Math.round(angle / 45) * 45)+'.png">'+
             '<br><span class="my-div-span">'+realTimeRecord.vehicule.matricule +'</span>'
        });
        this.imageUri = this.imagescar + "c2x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
        }else{
          icon = L.divIcon({
          iconSize: [200, 30],
          iconAnchor: [15, 15],
          popupAnchor: [10, -25],
          className: 'my-div-icon',
           html: '<img class="my-div-image" src="'+this.imagescar+'c3x'
           +Math.abs(Math.round(angle / 45) * 45)+'.png">'+
              '<br><span class="my-div-span">'+realTimeRecord.vehicule.matricule +'</span>'
        });
           this.imageUri = this.imagescar + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
        }
       }

        
      }else{
        icon = L.divIcon({
          iconSize: [200, 30],
          iconAnchor: [15, 15],
          popupAnchor: [10, -25],
          className: 'my-div-icon',
           html: '<img class="my-div-image" src="'+this.imagescar+'c3x'
           +Math.abs(Math.round(angle / 45) * 45)+'.png">'+
              '<br><span class="my-div-span">'+realTimeRecord.vehicule.matricule +'</span>'
        });
        this.imageUri = this.imagescar + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
       
      }



      if (this.isValidPoint(realTimeRecord.coordinate)){
       // this.mapService.removeAllRtMarkers();
      // this.mapService.removeAllRtMarkerstest();
        marker = new Marker(realTimeRecord.coordinate);
      realTimeRecord.icon = this.imageUri;



       let displaycurrentPath = false;
     /* if (this.currentPathClickedDeviceIds != null && this.currentPathClickedDeviceIds.indexOf(realTimeRecord.idRealTimeRecord) != -1) {
        displaycurrentPath = true;
        this.pathDrawn = true;
      }*/

      // if (this.isCurrentPathClicked == true && this.currentPathClickedDeviceId == realTimeRecord.idRealTimeRecord) {
      //               displaycurrentPath = true;
      //           }
      //  this.geocodingService.inverseGeoconding(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng, 18).subscribe(adress => {
      //   realTimeRecord.geocoding = this.getGeocoding(adress.address);
      //   realTimeRecord.geocodingDetails = adress.display_name;
      //   this.updateSpecificGroups(realTimeRecord);


      // },(err) => {

      // });
       /*console.log(this.dataManagementService.getDriverName(realTimeRecord.vehicule.driver));

       console.log(realTimeRecord.realTimeRecordStatus);
      console.log(realTimeRecord.ignition);
      console.log(realTimeRecord.speed);
       console.log(this.imageUri);*/
       marker.bindPopup(popup);
        
       this.mapService.updateRtMarker({
                    id: realTimeRecord.idRealTimeRecord,
                    value: marker,
                    icon: icon,
                    angle: 0
                }, displaycurrentPath);
           
         marker.on('click', () => {
             this.show = true ;
             console.log("",this.show);
             let vehicule = this.getVehicule(realTimeRecord.idRealTimeRecord);
            // console.log(vehicule);
             this.groupid = vehicule.idGroup;
            // console.log(this.groupid );
            this.selectedDevice = realTimeRecord.idRealTimeRecord;
         
            //this.getindexGroup(this.groupid);
            this.getindexVehicule(this.selectedDevice);
          
            console.log(this.id1);
            console.log(this.id2);
          });

         this.mapService.map.on('click', () => {
             this.show =false ;

          });
      }
      
      //let markerGroup = L.featureGroup();
      //markerGroup.addLayer(marker);
       
      
     

      //this.mapService.map.addLayer(markerGroup).on('click', ()=> {
      //this.events.publish('Showinfo', true)
      //});;

      //const polylineOptions: L.PolylineOptions = {};
     


      


/*

let markerClusterGroupOptions: L.MarkerClusterGroupOptions = {};
markerClusterGroupOptions = {
    showCoverageOnHover: true,
    zoomToBoundsOnClick: false,
    spiderfyOnMaxZoom: true,
    removeOutsideVisibleBounds: false,
    animate: true,
    animateAddingMarkers: false,
    disableClusteringAtZoom: 12,
    maxClusterRadius: 40,
    //polygonOptions: polylineOptions,
    singleMarkerMode: true,
    //spiderLegPolylineOptions: polylineOptions,
    //spiderfyDistanceMultiplier: 2,
    chunkedLoading: false,
    chunkDelay: 100
};

let markerClusterGroup: L.MarkerClusterGroup;
markerClusterGroup = L.markerClusterGroup();
markerClusterGroup = L.markerClusterGroup(markerClusterGroupOptions);


      //---cluster--
      //var markers = L.markerClusterGroup({ spiderfyOnMaxZoom: false, showCoverageOnHover: false, zoomToBoundsOnClick: false });
      markerClusterGroup.addLayer(marker);
      this.mapService.map.addLayer(markerClusterGroup)

*/
     
    }
    
   
 
//getcolor
carStatusColor(s):string{
  if (s.realTimeRecordStatus == 'VALID') {
        if(s.ignition== true){
          if(s.speed > 0 ){
            this.carStatus = "En route..";
         return "green";

     }else{
       this.carStatus = "En arrêt provisoirement..";

          return "blue";

        
     }}else{
       if(s.speed == 0 ){
        this.carStatus = "En arrêt ";
         return "orange";

        }else{
           this.carStatus = "Problèmes techniques..";
          return "red";
       }

        

}
 }else{
        this.carStatus = "Problèmes techniques..";
        return "red";
      }
}


//--------------


voirInfo(){

 let vehicule = this.getVehicule(this.selectedDevice);
 let group = this.getGroup(this.groupid);
  
 let selectedV = {"group" :group,"vehicule" :vehicule,"indexGroup":this.id1, "indexVehicule" :this.id2};


       this.navCtrl.push(InfoTrackerPage,{group: selectedV});



}


voirHistorique(){

 
    let selectedV = {"group" :this.groupid,"selectedDeviceId" :this.selectedDevice,"indexGroup":this.id1, "indexVehicule" :this.id2};



      this.navCtrl.push(HistoricalForm,{group: selectedV});



}


getGroup(groupid) : number{
if (this.groups)
  for(let i=0 ;i<this.groups.length;i++){
    if(groupid == this.groups[i].idGroupe){
      return this.groups[i];
    }
  }

}

getindexGroup(groupid) : number{
if (this.groups)
  for(let i=0 ;i<this.groups.length;i++){
    if(groupid == this.groups[i].idGroupe){
      return i;
    }
  }

}

getindexVehicule(selectedDevice) {
if (this.groups)
    for (let i = 0; i < this.groups.length; i++) {
      
      for (let j = 0; j < this.groups[i].vehicules.length; j++) {
       
        if (this.groups[i].vehicules[j].idDevice == selectedDevice) {
           console.log("i",i);
         console.log("j",j);
          this.id1 = i;
          this.id2 = j;
         // break;
        }
      }
      //break;

    }

}

getVal($event){
 console.log(this.searchbar.getSelection());
 console.log($event); 
 let vehicule:Vehicule;
 vehicule = $event;
 
 if (vehicule){
   vehicule.realTimeRecord = new RealTimeRecord();
      this.realTimeService.getRealTimeRecord(vehicule.idDevice).subscribe(y => {
        vehicule.realTimeRecord = y;
        this.mapService.map.setView(y.coordinate, 25);
      });
 }
      

}

searchByNameShow(){
  this.searchfield = !this.searchfield;
  
}

  reCalculeRealTimeRecord() {
    if (this.vehicule) {
      this.vehicule.realTimeRecord = new RealTimeRecord();
      this.realTimeService.getRealTimeRecord(this.selectedDevice).subscribe(y => {
        this.vehicule.realTimeRecord = y;
        this.vehicule.realTimeRecord.vehicule = new RealTimeRecord();
        this.vehicule.realTimeRecord.vehicule = this.vehicule;
       // this.vehicule.odo=this.dataManagementService.getOdoFromRecord(this.vehicule,this.vehicule.realTimeRecord.accum_odo);
        this.trackRealTimeRecord(this.vehicule.realTimeRecord);
      });
    }
  }
 
loadMap(){
  
    this.initMap();
    this.loader = this.loadingCtrl.create({
      content: "Veuillez attendre..."
    });

    //this.loader.present();
    //this.openGroupsModal();
    //this.loader.dismiss();
    let date1 = new Date()

    //console.log( date1.setHours(0,0,0,0));
   let loader= this.loading.create();
    loader.present();
    this.mapService.removeAllRtMarkerstest();
    this.loadGroups();
    this.getAllRealTimeRecords();
    loader.dismiss();
    
   
    

    this.realTimeService.getAllRealTimeRecords().subscribe(realTimeRecords => {
         this.mapService.centerMap(realTimeRecords, 12);
         });

   setInterval(() => {
      if(!this.history){
    this.getAllRealTimeRecords();
    
    console.log("refresh n:",++this.i);

      }
      //this.reCalculeRealTimeRecord();
    
    }, 20000);
}

  // open menu
  openmenu() {
    
    if (!this.charged){
      
      this.chargingGroupInfoInSideBar();
      this.charged = true;
    }
    this.menu.open();
  }

  openmodalrealtime() {
    this.show=false;
    this.history=false;

    this.resultopened = false;
    this.openStopResult = false;
    this.openMileageResult = false;
    this.previousPathdrawn = false;
    this.pathDrawn = false;
    this.clearPolylines();
    this.groupmodal.present();
  }



  //initialisation du map
  initMap() {
     if (this.mapService.map){
       this.mapService.map.off();
       this.mapService.map.remove();
     } 
    let map = L.map('historicalMap', {
      attributionControl:false,
      zoomControl: false,
      center: L.latLng(36.754423, 10.197877),
      zoom: 10,
      minZoom: 3,
      maxZoom: 20,
      //maxNativeZoom: 17,
      layers: [this.mapService.baseMaps.OpenStreetMap]
    });
    L.control.layers(this.mapService.baseMaps, null, {
      position: 'bottomright'
    }).addTo(map);
    L.control.zoom({
      position: 'bottomleft'
    }).addTo(map);
    this.mapService.map = map;
    this.onMapReady(this.mapService.map);
    console.log("map all good");
    this.mapService.mapLoaded.emit(true);
  }

onMapReady(map: L.Map) {
    setTimeout(() => {
      map.invalidateSize();
    }, 0);
 }


  viewDash(){
    if (this.selectedDevice) {
      let vehicule = this.getVehicule(this.selectedDevice);
      let group = this.getGroup(this.groupid);
      // console.log("eeeeeeeeeeee",vehicule.realTimeRecord)
      let selectedV = {"group" :group,"vehicule" :vehicule,"indexGroup":this.id1, "indexVehicule" :this.id2};
      this.navCtrl.push(DashboardPage,{group: selectedV});
    }
  }
  //draw itineraire
  drawpath() {
    
    if (this.selectedDevice) {
      let vehicule = this.getVehicule(this.selectedDevice);
      // console.log("eeeeeeeeeeee",vehicule.realTimeRecord.coordinate.lat,vehicule.realTimeRecord.coordinate.lng)
      // console.log(this.currentlocationlat, this.currentlocationlng)
      
      if (this.currentlocationlat && this.currentlocationlng) {
        let options: LaunchNavigatorOptions = {
          start: [this.currentlocationlat, this.currentlocationlng],
          app: this.launchNavigator.APP.GOOGLE_MAPS

        };
        this.launchNavigator.navigate([vehicule.realTimeRecord.coordinate.lat,
                                       vehicule.realTimeRecord.coordinate.lng], options)
          .then(
            success => console.log('Launched navigator'),
            error => {
              let alert = this.alertCtrl.create({
                title: 'Attention',
                subTitle: 'Veuillez installer Google Maps ',
                buttons: ['Ok']
              });
              alert.present();
            }
          );
      } else {
        let alert = this.alertCtrl.create({
          title: 'Attention',
          subTitle: 'Veuillez activer GPS ',
          buttons: ['Ok']
        });
        alert.present();
      }
    } else {
      let alert = this.alertCtrl.create({
        title: 'Itinéraire',
        subTitle: 'Veuillez choisir un véhicule ',
        buttons: ['Ok']
      });
      alert.present();
    }

  }
  //open gestion de park
  openParc() {
    let data = {
      idDevice: this.vehicule,
      matricule: this.matricule
    }
    let gestparc = this.modalCtrl.create(GestionPark, {
      data
    });
    gestparc.present();


  }
  // (open modal) liste des groupes et véhicules (temps réel) 
  openGroupsModal() {
    this.pathpoirealtime = true;
    this.history=false;
    this.resultopened = false;
    this.openStopResult = false;
    this.openMileageResult = false;
    this.groupmodal = this.modalCtrl.create(GroupsPage);
    this.groupmodal.present();
    this.groupmodal.onDidDismiss(data => {
      if (data) {
        this.vehicule = data.vehicule;
        this.mapService.map.setView(data.vehicule.realTimeRecord.coordinate, 15);
        this.trackRealTimeRecord(data.vehicule.realTimeRecord);
      }
    });
    this.modalopen = false;
    this.dismissbutton = true;
  }

  //open POI Modal
  openPoiModal() {
    if (this.selectedDevice) {
      let pointInterest = new PointInterest();
      pointInterest.address = this.addresspoi;
      pointInterest.coordinate.lat = this.latpoi;
      pointInterest.coordinate.lng = this.lngpoi;
      let PoiModal = this.modalCtrl.create(Poi, {
        pointInterest
      });
      PoiModal.present();
      PoiModal.onDidDismiss(form => {
        if (form.pointinterest.name != null) {
          if (pointInterest.type == "MARKER") {
            let circle = L.circle(pointInterest.coordinate, {
              color: 'red',
              fillColor: '#f03',
              fillOpacity: 0.1,
              radius: pointInterest.ray
            });
            this.mapService.addCircle(circle);
            setTimeout(() => {
              this.mapService.removeCirclesFromMap();
            }, 4000);
          }


        }
      });
    } else {
      let alert = this.alertCtrl.create({
        title: 'POI',
        subTitle: 'Veuillez choisir un véhicule ',
        buttons: ['Ok']
      });
      alert.present();
    }
  }

  //remove polylines and markers from map
  clearPolylines() {
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    this.pathDrawn = false;
  }

  //Getting old real time record
  getOldRealTimeRecord(id: number): RealTimeRecord {
    let result = this.oldRealTimeRecords.filter(rt => {
      return rt.idRealTimeRecord == id;
    });
    if (result) return result[0];
    else return null;
  }

  // Compare two coordinate
  compareTwoCoordinate(p1, p2) {
    if (p1.lat == p2.lat && p1.lng == p2.lng) return true;
    else false;
  }
  //
  getGeocoding(address: any): string {
    let geocoding: string = null;
    if (address) {
      if (address.road != null) {
        geocoding = address.road;
      }
      if (address.neighbourhood != null) {
        geocoding = geocoding ? geocoding + ' ' + address.neighbourhood : address.neighbourhood;
      }
      if (address.city != null) {
        geocoding = geocoding ? geocoding + ' (' + address.city + ')' : address.city;
      }
      if (geocoding == null) {
        geocoding = 'chargement..';
      }
    }
    return geocoding;
  }



  //temps reel 
  /*trackRealTimeRecord(realTimeRecord: RealTimeRecord) {
    // this.myGauge.value(realTimeRecord.speed); 
    this.pathDrawn = false;
    let angle = 0;
    var date = new Date(realTimeRecord.recordTime);
    realTimeRecord.recordTime = new Date(new Date(realTimeRecord.recordTime).setHours(new Date(realTimeRecord.recordTime).getHours() - 1));
    var minutes = date.getMinutes() + "";
    if (minutes.length == 1) {
      minutes = "0" + date.getMinutes();
    }
    let icon;
    let marker;
    let popup;

    if (!this.dataManagementService.pointInterests) {
      this.dataManagementService.getAllPointInterests().subscribe(pointInterests => {
        this.dataManagementService.pointInterests = pointInterests;
        realTimeRecord.relativePosition = this.dataManagementService.getRelativePosition(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng);
      })
    } else {
      realTimeRecord.relativePosition = this.dataManagementService.getRelativePosition(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng);
    }
    if (realTimeRecord.type === "AA") {
      angle = realTimeRecord.rotationAngle * 8;
    }
    if (this.oldRealTimeRecords && realTimeRecord.type === "GPRMC") {
      let oldRealTimeRecord = this.getOldRealTimeRecord(realTimeRecord.idRealTimeRecord);
      if (oldRealTimeRecord) {
        if (!this.compareTwoCoordinate(oldRealTimeRecord.coordinate, realTimeRecord.coordinate)) {
          angle = Math.atan2(realTimeRecord.coordinate.lng - oldRealTimeRecord.coordinate.lng, realTimeRecord.coordinate.lat - oldRealTimeRecord.coordinate.lat) * 180 / Math.PI;
          this.angles.set(realTimeRecord.idRealTimeRecord, angle);
        } else {
          angle = this.angles.get(realTimeRecord.idRealTimeRecord);
        }
      }
    }
    popup = '<b>Chauffeur:</b> ' + this.dataManagementService.getDriverName(realTimeRecord.vehicule.driver) +
      //   '<br><b>Matricule:</b> ' + realTimeRecord.vehicule.matricule +
      '<br><b>Mark:</b> ' + realTimeRecord.vehicule.mark +
      // '<br><b>Lat,Lng:</b><i> [' + this.PipeLngLat(realTimeRecord.coordinate.lat) + ',' + this.PipeLngLat(realTimeRecord.coordinate.lng) + ']</i><br><b>Vitesse :</b>' + realTimeRecord.speed +
      //   "<br><b>date et l'heure:</b> " + (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + minutes +
      "<br><b>Signal GSM:</b> " + realTimeRecord.signal +
      " <i class='fa fa-wifi' aria-hidden='true'></i><br><b>Sat en vue:</b> " + realTimeRecord.satInView + " <i class='fa fa-globe' aria-hidden='true'></i>";
    this.selectedDevice = this.vehicule.device.idDevice;
    this.realtimecoord = realTimeRecord.coordinate;
    this.matricule = realTimeRecord.vehicule.matricule;
    this.latpoi = this.PipeLngLat(realTimeRecord.coordinate.lat);
    this.lngpoi = this.PipeLngLat(realTimeRecord.coordinate.lng);
    this.vitesse = realTimeRecord.speed;
    this.dataManagementService.inverseGeoconding(this.latpoi, this.lngpoi, 17).subscribe(res => {
      this.addresspoi = res.display_name;
    }, (err) => {});



    marker = new Marker(realTimeRecord.coordinate, {
      rotationAngle: angle
    });

    if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed == 0 && realTimeRecord.ignition == true) {
      icon = new Icon({
        iconUrl: imagescar + "c4x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -10],
        iconSize:     [15, 60], 
      });
      this.pathDrawn = true;
      this.imageUri = imagescar + "c4x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
    }
    if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed > 0) {
      icon = new Icon({
        iconUrl: imagescar + "c1x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -25],
        iconSize:     [15, 60], 

      });
      this.imageUri = imagescar + "c1x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
    }
    if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed == 0 && realTimeRecord.ignition == false) {
      icon = new Icon({
        iconUrl: imagescar + "c2x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -25],
        iconSize:     [15, 60], 
      });
      this.imageUri = imagescar + "c2x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
    }
    if (realTimeRecord.realTimeRecordStatus == 'NON_VALID' || realTimeRecord.realTimeRecordStatus == 'TECHNICAL_ISSUE') {
      icon = new Icon({
        iconUrl: imagescar + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -25],
        iconSize:     [15, 60], 
      });
      this.imageUri = imagescar + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
    }
    realTimeRecord.icon = this.imageUri;


    icon = new Icon({
      iconUrl: realTimeRecord.icon,
      iconAnchor: [-2, 30],
      popupAnchor: [10, -25],
      iconSize:     [30, 30], 

    });
    if (realTimeRecord.geocoding) {
      popup = popup + '<hr><b>' + realTimeRecord.geocoding + '</b><br>';
    }
    this.geocodingService.inverseGeoconding(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng, 18).subscribe(adress => {
      //  popup = popup + '<hr><b>' + adress.display_name + '</b><br>';
      if (realTimeRecord.relativePosition) {
        //popup = popup + '<hr><center><span class="leaflet-pelias-layer-icon-container"><div class="leaflet-pelias-layer-icon leaflet-pelias-layer-icon-point"></div></span><strong>' + realTimeRecord.relativePosition + '</strong></center>';
        this.relativeposition = realTimeRecord.relativePosition;
      } else {
        this.relativeposition = realTimeRecord.geocoding;
      }
      // realTimeRecord.geocoding = this.getGeocoding(adress.address);
      // realTimeRecord.geocodingDetails = adress.display_name;
      //  this.updateSpecificGroups(realTimeRecord);
      let displaycurrentPath = false;
      if (this.currentPathClickedDeviceIds != null && this.currentPathClickedDeviceIds.indexOf(realTimeRecord.idRealTimeRecord) != -1) {
        displaycurrentPath = true;
        this.pathDrawn = true;
      }
      //  this.clearPolylines();
      this.mapService.removeAllRtMarkers();
      this.mapService.updateRtMarkertest(realTimeRecord.coordinate, popup, icon, realTimeRecord.idRealTimeRecord, displaycurrentPath);
      if (realTimeRecord.idRealTimeRecord == this.selectedDevice) {
        if (realTimeRecord.vehicule.driver) {
          this.driverphone = realTimeRecord.vehicule.driver.telephone;
        }
        if (this.pathDrawn == false && realTimeRecord.speed > 0) {
          this.displayCurrentPath(realTimeRecord.idRealTimeRecord);
        }
      }
    }, (err) => {

      let displaycurrentPath = false;
      if (this.currentPathClickedDeviceIds != null && this.currentPathClickedDeviceIds.indexOf(realTimeRecord.idRealTimeRecord) != -1) {
        displaycurrentPath = true;
      }

      // c'est normal => tu test ici si le record = le current !
      if (realTimeRecord.idRealTimeRecord == this.selectedDevice) {
        marker.bindPopup(popup);
        this.mapService.updateRtMarkertest(realTimeRecord.coordinate, popup, icon, realTimeRecord.idRealTimeRecord, displaycurrentPath);
      }
    });
  }*/

  //
  PipeLngLat(value: any) {
    return this.pipe.transform(value, '2.2-6');
  }

  //update du groupe
  updateSpecificGroups(realTimeRecord: RealTimeRecord) {
    if (this.groups)
      this.groups.forEach(group => {
        if (group)
          group.vehicules.forEach(vehicule => {
            if (vehicule.idDevice == realTimeRecord.idRealTimeRecord)
              vehicule.realTimeRecord = realTimeRecord;
          });
      });
  }

  //alert lancement Moteur
  // AlertLancementMoteur(deviceId) {
  //   this.show = !this.show;
  //   let alert = this.alertCtrl.create({
  //     title: 'Attention',
  //     message: 'Êtes-vous sûr ?',
  //     buttons: [{
  //         text: 'Cancel',
  //         role: 'cancel',
  //         handler: () => {

  //         }
  //       },
  //       {
  //         text: 'Start',
  //         handler: () => {
  //           this.startEngine(deviceId);
  //         }
  //       }
  //     ]
  //   });
  //   alert.present();
  // }

  // //start moteur
  // startEngine(deviceId) {
  //   this.realTimeService.startEngine(deviceId).subscribe(cmdSended => {
  //     alert("commande Lancement moteur envoyé !");
  //   });
  // }


goToHistoricalForm(){

  this.navCtrl.push(HistoricalForm);

}

  //alert arret moteur
  // AlertArretMoteur(deviceId) {
  //   let alert = this.alertCtrl.create({
  //     title: 'Attention',
  //     message: 'Êtes-vous sûr ?',
  //     buttons: [{
  //         text: 'Cancel',
  //         role: 'cancel',
  //         handler: () => {}
  //       },
  //       {
  //         text: 'Arrêt',
  //         handler: () => {
  //           this.stopEngine(deviceId);
  //         }
  //       }
  //     ]
  //   });
  //   alert.present();
  // }

  // //stop moteur
  // stopEngine(deviceId) {
  //   this.realTimeService.stopEngine(deviceId).subscribe(cmdSended => {
  //     alert("commande Arrêt moteur envoyé !");
  //   });
  // }

  //open result "historique des trajets"
  openResultsModal() {
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    let pathsListModal = this.modalCtrl.create(PathsList, {
      paths: this.paths
    });
    if (this.paths == null) {
      let alert = this.alertCtrl.create({
        title: 'Historique',
        subTitle: 'Aucune informations',
        buttons: ['Ok']
      });
      alert.present();
    } else {
      pathsListModal.present();
      pathsListModal.onDidDismiss(pathClicked => {
        if (pathClicked == null) {
          this.openFormModal();

        } else if (pathClicked == 1) {

        } else {
          this.drawPath(pathClicked);
        }



        this.resultopened = true;
        this.openStopResult = false;
        this.openMileageResult = false;
      });
    }
  }

  // desiner le trajet
  drawPath(path: any) {

    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    this.historicalService.getPathDetails(path.deviceId, {
      startDate: path.beginPathTime,
      endDate: path.endPathTime
    }).subscribe(points => {
      let stopMarkers: Marker[] = [];
      points.stops.forEach(stop => {
        let popup = "<img src='" + this.imagesDir + "stop_smal.png" + "'/> Durée d'arrêt : " + stop.stopDurationStr;
        let stopMarker = L.marker({
          lat: stop.stopLatitude,
          lng: stop.stopLongitude
        });
        stopMarker.addTo(this.mapService.map);
        stopMarker.on('click', () => {
          this.mapService.map.setView({
            lat: stop.stopLatitude,
            lng: stop.stopLongitude
          }, 14);
        });
        this.dataManagementService.inverseGeoconding(stop.stopLatitude, stop.stopLongitude, 18).subscribe(adress => {
          let truncatedDisplayName = adress.display_name;
          let countCommas = 0;
          for (var i = 0, len = adress.display_name.length; i < len; i++) {
            if (adress.display_name[i] == ',') {
              countCommas = countCommas + 1;
            } else if (countCommas >= 5) {
              truncatedDisplayName = adress.display_name.substring(0, i - 1);
              break;
            }
          }
          popup = popup + '<br><hr><b>' + truncatedDisplayName + '</b>';
          stopMarker.bindPopup(popup);
        });
        stopMarker.setIcon(new Icon({
          iconUrl: this.imagesDir + "stop_smal.png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25]
        }));
        this.mapService.addMarker(stopMarker);
      });
      let polyline = L.polyline(points.coordinates, {
        color: '#0031D9',
        weight: 3
      });
      points.coordinates.forEach((coordinate, i) => {
        let marker = L.marker(coordinate);
        if (i != 0 && i != points.coordinates.length - 1) {
          marker.setIcon(new Icon({
            iconUrl: this.imagesDir + "green-point.png",
            iconAnchor: [2, 2]
          }));
          var pointDatePipe = new DatePipe(coordinate.date);
          let popup = '<b>Heure:</b> ' + pointDatePipe.transform(coordinate.date, 'dd/MM/yyyy HH:mm:ss') + '<b><br>vitesse:</b> ' + coordinate.speed + ' Km/h';
          marker.bindPopup(popup);
          marker.on('click', () => {
            this.mapService.map.setView(coordinate, 17);
          });
          this.mapService.addMarker(marker);
        }
      });
      let startMarker = L.marker({
        lat: path.beginPathLatitude,
        lng: path.beginPathLongitude
      });
      let startTime: any = path.beginPathTime;
      var startDatePipe = new DatePipe(startTime);
      startMarker.bindPopup('<b> Lieu de début: </b>' + path.beginPathGeocoding + '<b></i><br>Temps de début du trajet : </b>' + startDatePipe.transform(startTime, 'dd/MM/yyyy HH:mm:ss'));
      startMarker.setIcon(new Icon({
        iconUrl: this.imagesDir + "startMarker.png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -25]
      }));
      this.mapService.addMarker(startMarker);
      if (path.endPathLatitude != null && path.endPathLongitude != null && path.endPathTime != null) {
        var endMarker = L.marker({
          lat: path.endPathLatitude,
          lng: path.endPathLongitude
        });
        let endTime: any = path.endPathTime;
        var endDatePipe = new DatePipe(endTime);
        endMarker.bindPopup('<b> Lieu de fin: </b>' + path.endPathGeocoding + '<br><b>Temps de fin du trajet : </b>' + endDatePipe.transform(endTime, 'dd/MM/yyyy HH:mm:ss') +
          '<br><b> Durée du trajet : </b>' + path.pathDurationStr + "<br><b> Durée d'arrêt : </b>" + path.nextStopDurationStr + "<br><b> Vitesse maximum : </b>" +
          path.maxSpeed + " Km/h <br><b> Kilometrage parcouru : </b>" + path.distanceDriven.toFixed(2) + ' Km'
        );
        endMarker.setIcon(new Icon({
          iconUrl: this.imagesDir + "endMarker.png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25]
        }));
        this.mapService.addMarker(endMarker);
      }
      this.mapService.addPolyline(polyline);
      var middle = points.coordinates[Math.round((points.coordinates.length - 1) / 2)];
      this.mapService.map.setView(middle, 12);
    });
    this.modalopen = true;
  }

  // trajet en courant temps reel
  displayCurrentPath(deviceId: number) {
    this.realTimeService.getCurrentPath(deviceId).subscribe(currentPath => {
      if (currentPath != null) {
        let polyline = L.polyline(currentPath.coordinates, {
          color: '#0031D9',
          weight: 3
        });
        currentPath.coordinates.forEach((coordinate, i) => {
          let marker = new Marker(coordinate);
          if (i != 0 && i != currentPath.coordinates.length - 1) {
            marker.setIcon(new Icon({
              iconUrl: this.imagesDir + "green-point.png",
              iconAnchor: [2, 2]
            }));
            this.mapService.addMarker(marker);
          }
        });
        let startMarker = L.marker({
          lat: currentPath.beginPathLatitude,
          lng: currentPath.beginPathLongitude
        });
        startMarker.setIcon(new Icon({
          iconUrl: this.imagesDir + "startMarker.png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25]
        }));
        startMarker.on('click', () => {
          this.mapService.map.setView({
            lat: currentPath.beginPathLatitude,
            lng: currentPath.beginPathLongitude
          }, 14);
        });
        this.mapService.addMarker(startMarker);
        this.mapService.addPolyline(polyline);
        this.pathDrawn = true;
      }
      this.previousPathdrawn = true;

    }, (err) => {
      this.previousPathdrawn = false;
    });
  }

  //
  processGeocoding(geocoding: string): string {
    if (geocoding != null) {
      let array = geocoding.split(',', 3);
      let smallerGeocoding = '';
      array.forEach(word => {
        smallerGeocoding = smallerGeocoding + ', ' + word;
      });
      smallerGeocoding = smallerGeocoding.slice(2, smallerGeocoding.length);
      return smallerGeocoding;
    } else
      return null;
  }

  //l'appel du chauffeur
  calldriver(number: string) {



    if (number) {
      this.callNumber.callNumber(number, true)
        .then(() => console.log('Launched dialer!'))
        .catch(() => console.log('Error launching dialer'));
    } else {
      let alert = this.alertCtrl.create({
        title: 'Error',
        subTitle: 'Numéro introuvable',
        buttons: ['Ok']
      });
      alert.present();
    }


  }

  //draw all point interests
  drawPointInterests() {
    this.mapService.removeMarkersPoiFromMap();
    this.mapService.removePolygonsPoiFromMap();
    this.mapService.removeCirclesFromMap();
    if (this.poisInMap) {
      this.poisInMap = false;
      return;
    } else {

      if (this.dataManagementService.pointInterests == null) {
        this.dataManagementService.getAllPointInterests().subscribe(pointInterests => {
          this.dataManagementService.pointInterests = pointInterests;
          this.pointInterests = pointInterests;
          pointInterests.forEach(pointInterest => {
            this.drawPointInterest(pointInterest);
          });
        });
      } else {
        this.dataManagementService.pointInterests.forEach(pointInterest => {
          this.drawPointInterest(pointInterest);
        });
      }
      this.poisInMap = true;
    }
  }

  //draw une seule point d'interet
  drawPointInterest(pointInterest: PointInterest) {
    let popup = '<b>Nom : </b> ' + pointInterest.name + '<br><b>Adresse</b>' + pointInterest.address + '';
    let marker = null;
    // if (pointInterest.type == "POLYGON") {
    //   let polygon = new Polygon(pointInterest.decode);
    //   this.mapService.addPolygonPoi(polygon);
    // }
    marker = L.marker(pointInterest.coordinate);
    marker.setIcon(new Icon({
      iconUrl: this.imagesPOIDir + pointInterest.imageUri,
      iconAnchor: [-2, 10],
      popupAnchor: [10, -25]
    }));
    this.mapService.addMarkerPoi(marker);
    marker.on("click", () => {
      this.mapService.map.setView(pointInterest.coordinate, 17);
    });
    marker.bindPopup(popup);
  }

  // historique des trajet + historique des stops + historique de kilometrage
  openFormModal() {
   let time_difference:number = this.globalService.gettime_difference();
   console.log(time_difference);
    if (this.selectedDevice) {
    
      let formModal = this.modalCtrl.create(HistoricalForm);
      formModal.present();
      formModal.onDidDismiss(form => {
        
        //historique des trajets
        if (form.endDate != "" && form.startDate != "" && form.list == "trajet") {
          let firstDateTime = new Date(form.startDate);
          let lastDateTime = new Date(form.endDate);
          this.loader = this.loadingCtrl.create({
            content: "Veuillez attendre..."
          });
          this.loader.present();
          if (form.startDate == null && form.endDate == null) {
            this.loader.dismiss();
            let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: 'Informations erronées',
              buttons: ['Ok']
            });
            alert.present();
          }
          this.allPaths = this.historicalService.getAllPaths(this.selectedDevice, {
            startDate: firstDateTime,
            endDate: new Date(lastDateTime.getTime() + 3600000)
          }).subscribe(paths => {
            if (paths.length) {
              this.pathpoirealtime = false;
              this.pathDrawn = false;
              this.previousPathdrawn = false;
              this.clearPolylines();
              this.history=true;
              this.mapService.removeAllRtMarkers();

              this.paths = paths;
              let lastLat = paths[0].beginPathLatitude;
              let lastlng = paths[0].beginPathLongitude;
              let i = 0;
              this.paths.forEach(path => {
                let startHour: any = path.beginPathTime;
                let startTime: any = startHour + 0 * time_difference;
                path.displayBeginPathTime = startTime;
                if (path.endPathTime != null) {
                  let endHour: any = path.endPathTime;
                  let endTime: any = endHour + 0 * time_difference;
                  path.displayEndPathTime = endTime;
                }
                path.beginPathGeocodingDetails = this.dataManagementService.getRelativePosition(path.beginPathLatitude, path.beginPathLongitude);
                path.beginPathGeocoding = path.beginPathGeocodingDetails;
                if (path.beginPathGeocodingDetails == null) {
                  this.geocodingService.inverseGeoconding(path.beginPathLatitude, path.beginPathLongitude, 17).subscribe(adress => {
                    path.beginPathGeocodingDetails = adress.display_name;
                    if (adress.address.road != null && adress.address.neighbsourhood != null && adress.address.city != null) {
                      path.beginPathGeocoding = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                      path.beginPathGeocodingDetails = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                    } else {
                      let truncatedDisplayName = adress.display_name;
                      let countCommas = 0;
                      for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                          countCommas = countCommas + 1;
                        } else if (countCommas >= 5) {
                          truncatedDisplayName = adress.display_name.substring(0, i - 1);
                          path.beginPathGeocoding = truncatedDisplayName;
                          path.beginPathGeocodingDetails = path.beginPathGeocoding;
                          break;
                        }
                      }
                    }
                  }, (err) => {
                    path.beginPathGeocodingDetails = null;
                    path.beginPathGeocoding = null;
                  });
                }
                path.endPathGeocodingDetails = this.dataManagementService.getRelativePosition(path.endPathLatitude, path.endPathLongitude);
                path.endPathGeocoding = path.endPathGeocodingDetails;
                if (path.endPathGeocodingDetails == null) {
                  this.geocodingService.inverseGeoconding(path.endPathLatitude, path.endPathLongitude, 17).subscribe(adress => {
                    path.endPathGeocodingDetails = adress.display_name;
                    if (adress.address.road != null && adress.address.neighbsourhood != null && adress.address.city != null) {
                      path.endPathGeocoding = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                      path.endPathGeocodingDetails = path.endPathGeocoding;
                    } else {
                      let truncatedDisplayName = adress.display_name;
                      let countCommas = 0;
                      for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                          countCommas = countCommas + 1;
                        } else if (countCommas >= 5) {
                          truncatedDisplayName = adress.display_name.substring(0, i - 1);
                          path.endPathGeocoding = truncatedDisplayName;
                          path.endPathGeocodingDetails = path.endPathGeocoding;
                          break;
                        }
                      }
                    }
                  }, (err) => {
                    path.endPathGeocodingDetails = null;
                    path.endPathGeocoding = null;
                  });
                }
                i++;
                lastLat = path.beginPathLatitude;
                lastlng = path.beginPathLongitude;
              });

            }
            this.loader.dismiss();
            this.openResultsModal();
          }, (err) => {});
        }
        //historique des arret
        if (form.endDate != "" && form.startDate != "" && form.list == "arret") {
          let firstDateTime = new Date(form.startDate);
          let lastDateTime = new Date(form.endDate);
          this.loader = this.loadingCtrl.create({
            content: "Veuillez attendre..."
          });
          this.loader.present();
          if (form.startDate == null && form.endDate == null) {
            this.loader.dismiss();
            let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: 'Informations erronées',
              buttons: ['Ok']
            });
            alert.present();
          }
          this.allPaths = this.historicalService.getAllStops(this.selectedDevice, {
            startDate: firstDateTime,
            endDate: new Date(lastDateTime.getTime() + 3600000)
          }).subscribe(stops => {
            if (stops && stops.length) {
              this.pathpoirealtime = false;
              this.pathDrawn = false;
              this.previousPathdrawn = false;
              this.clearPolylines();
              this.history=true;
              this.mapService.removeAllRtMarkers();

              this.stops = stops;
              this.stops.forEach(stop => {
                stop.geocodingDetails = this.dataManagementService.getRelativePosition(stop.stopLatitude, stop.stopLongitude);
                stop.geocoding = stop.geocodingDetails;
                stop.beginStopTime = stop.beginStopTime + 0 * time_difference;
                if (stop.geocodingDetails == null) {
                  this.geocodingService.inverseGeoconding(stop.stopLatitude, stop.stopLongitude, 17).subscribe(adress => {
                    stop.geocodingDetails = adress.display_name;
                    if (adress.address.road != null && adress.address.neighbourhood != null && adress.address.city != null) {
                      stop.geocoding = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                      stop.geocodingDetails = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                    } else {
                      let truncatedDisplayName = adress.display_name;
                      let countCommas = 0;
                      for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                          countCommas = countCommas + 1;
                        } else if (countCommas >= 5) {
                          truncatedDisplayName = adress.display_name.substring(0, i - 1);
                          stop.geocoding = truncatedDisplayName;
                          stop.geocodingDetails = stop.geocoding;
                          break;
                        }
                      }
                    }
                  }, (err) => {
                    stop.geocodingDetails = null;
                    stop.geocoding = null;
                  });
                }
              });
            }
            this.loader.dismiss();
            this.openStopsResultsModal();
          }, (err) => {});
        }

        //historique kilometrage
        if (form.endDate != "" && form.startDate != "" && form.list == "kilo") {
          let firstDateTime = new Date(form.startDate);
          let startHour: any = new Date(form.startDate);
          let lastDateTime = new Date(form.endDate);
          this.loader = this.loadingCtrl.create({
            content: "Veuillez attendre..."
          });
          this.loader.present();
          if (form.startDate == null && form.endDate == null) {
            this.loader.dismiss();
            let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: 'Informations erronées',
              buttons: ['Ok']
            });
            alert.present();
          }
          this.AllPaths = this.historicalService.getAllMileages(this.selectedDevice, {
            startDate: startHour - (24 * 60 * 60 * 1000),
            endDate: new Date(lastDateTime.getTime() + 3600000)
          }).subscribe(mileages => {
            if(this.mileages){
              this.pathpoirealtime = false;
              this.pathDrawn = false;
              this.previousPathdrawn = false;
              this.clearPolylines();
            this.mapService.removeAllRtMarkers();
            this.history=true;
            }
            this.mileages = mileages;
            this.mileages.forEach(mileage => {
              let startHour: any = mileage.startHour;
              mileage.startHour = startHour + (60 * 60 * 1000);
            });
            this.totalMileage = this.mileages[this.mileages.length - 1];
            this.mileages.splice(this.mileages.length - 1);
            this.loader.dismiss();
            this.openMileageResultModal();
          }, (err) => {});
        }
      });
    } else {
      let alert = this.alertCtrl.create({
        title: 'Historique',
        subTitle: 'Veuillez choisir un véhicule ',
        buttons: ['Ok']
      });
      alert.present();
    }
  }

  //draw arret
  drawStop(stop: Stop) {
    if (this.stopClicked == null || this.stopClicked.beginStopTime != stop.beginStopTime) {
      this.stopClicked = new Stop();
      this.stopClicked.beginStopTime = stop.beginStopTime;
      this.stopClicked.endStopTime = stop.endStopTime;
    }
    this.mapService.removeMarkersFromMap();
    let marker = L.marker({
      lat: stop.stopLatitude,
      lng: stop.stopLongitude
    });
    let date = new Date(stop.beginStopTime);
    let beginStopTime: any = stop.beginStopTime;
    var pointDatePipe = new DatePipe(beginStopTime);
    let popup = "<b>Date debut d'arrêt: </b>" + pointDatePipe.transform(stop.beginStopTime, 'dd/MM/yyyy HH:mm:ss') + "<br><b>Durée d'arrêt: </b>" + stop.stopDurationStr + "<br><hr><b>" + stop.geocodingDetails + "</b>";
    marker.setIcon(new Icon({
      iconUrl: this.imagesDir + "endMarker.png",
      iconAnchor: [-2, 30],
      popupAnchor: [10, -25]
    }));
    marker.bindPopup(popup);
    marker.on('click', () => {
      this.mapService.map.setView({
        lat: stop.stopLatitude,
        lng: stop.stopLongitude
      }, 17);
    });
    marker.on('add', () => {
      marker.openPopup();
    });
    this.mapService.addMarker(marker);
    this.mapService.map.setView({
      lat: stop.stopLatitude,
      lng: stop.stopLongitude
    }, 15);
  }

  // open modal "historique de kilometrage" result
  openMileageResultModal() {
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    let mileageListModal = this.modalCtrl.create(MileageComponent, {
      mileages: this.mileages,
      totalMileage: this.totalMileage
    });
    if (this.mileages == null) {
      let alert = this.alertCtrl.create({
        title: 'Historique',
        subTitle: 'Aucune informations',
        buttons: ['Ok']
      });
      alert.present();
    } else {
      mileageListModal.present();
      mileageListModal.onDidDismiss(mileageClicked => {
        if (mileageClicked == null) {
          this.openFormModal();
        } else if (mileageClicked == 1) {

        } else this.drawMileage(mileageClicked);



      });
    }
    this.resultopened = false;
    this.openStopResult = false;
    this.openMileageResult = true;
  }

  // draw Kilometrage
  drawMileage(mileage: any) {
    if (this.mileageClicked == null || this.mileageClicked.startHour != mileage.startHour) {
      this.mileageClicked = new Mileage();
      this.mileageClicked.startHour = mileage.startHour;
      this.mileageClicked.endHour = mileage.endHour;
    }
    let startHour: any = mileage.startHour - (2 * 60 * 60 * 1000);
    this.historicalService.getMileageDetails(this.selectedDevice, {
      startDate: startHour,
      endDate: mileage.endHour
    }).subscribe(mileage => {
      let points = mileage.points;
      let stops = mileage.stops;
      let polyline = L.polyline(points, {
        color: '#0031D9',
        weight: 3
      });
      points.forEach((coordinate, i) => {
        let marker = L.marker(coordinate);
        if (i != 0 && i != points.length - 1) {
          marker.setIcon(new Icon({
            iconUrl: this.imagesDir + "green-point.png",
            iconAnchor: [2, 2]
          }));
          var pointDatePipe = new DatePipe(coordinate.date);
          let popup = '<b>Heure:</b> ' + pointDatePipe.transform(coordinate.date, 'dd/MM/yyyy HH:mm:ss') + '<b><br>vitesse:</b> ' + coordinate.speed + ' Km/h';
          marker.bindPopup(popup);
          marker.on('click', () => {
            this.mapService.map.setView(coordinate, 17);
          });
          this.mapService.addMarker(marker);
        }
      });
      stops.forEach((stop, i) => {
        let marker = L.marker({
          lat: stop.stopLatitude,
          lng: stop.stopLongitude
        });
        var pointDatePipe = new DatePipe(stop.beginStopTime);
        let popup = "<b>Date debut d'arrêt: </b>" + pointDatePipe.transform(stop.beginStopTime, 'dd/MM/yyyy HH:mm:ss') + "<br><b>Durée d'arrêt: </b>" + stop.stopDurationStr;
        marker.setIcon(new Icon({
          iconUrl: this.imagesDir + "stop_smal.png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25]
        }));
        marker.bindPopup(popup);
        marker.on('click', () => {
          this.mapService.map.setView({
            lat: stop.stopLatitude,
            lng: stop.stopLongitude
          }, 17);
        });
        this.mapService.addMarker(marker);
      });
      this.mapService.addPolyline(polyline);
      var middle = points[Math.round((points.length - 1) / 2)];
      //map center offset(axis y)
      // this.mapService.offsetMap(middle, 12, 0, -120);
    });
  }

  // open resultat des arrets
  openStopsResultsModal() {
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    let stopListModal = this.modalCtrl.create(StopList, {
      stops: this.stops
    });
    if (this.stops == null) {
      let alert = this.alertCtrl.create({
        title: 'Historique',
        subTitle: 'Aucune informations',
        buttons: ['Ok']
      });
      alert.present();
    } else {
      stopListModal.present();
      stopListModal.onDidDismiss(stopClicked => {
        if (stopClicked == null) {
          this.openFormModal();
        } else if (stopClicked == 1) {

        } else this.drawStop(stopClicked);
      });
    }
    this.resultopened = false;
    this.openStopResult = true;
  }

  isValidPoint(point: {
    lat: number,
    lng: number
  }) {
    if (point && point.lng !== 0 && point.lat !== 0) return true;
    else return false;
  }
  logout(): void {
    localStorage.removeItem('currentuser');
    this._app.getRootNav().setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/historical/historical.ts